import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class NirCompensationAgreementParent extends List {
  constructor(obj) {
    super(NirCompensationAgreement, obj)
  }
}

export class NirCompensationAgreement {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.agreementNumber = obj?.agreementNumber || null
    this.agreementDateFrom = obj?.agreementDateFrom || null
    this.agreementDateTo = obj?.agreementDateTo || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      agreementNumber: this.agreementNumber,
      agreementDateFrom: this.agreementDateFrom,
      agreementDateTo: this.agreementDateTo
    }
  }
}
